
define(["underscore"], function (_) {
  return {
    /**
      * This function uses to format the source context, saved in the server
      *
      * @param {object} source_context sources filter.
      * @param {string} tabName new of the selected tab.
      * @return {object} source_context  formated source_context.
      */
     parseInServerFormat: function(source_context, tabName) {
      if(!Array.isArray(source_context.constraints)) return source_context;

      var newSourceContext = Object.assign({}, source_context);
      var newConstraint = { view: {}, filter_datasources: {} };
      _.each(newSourceContext.constraints, function (con) {
        if (con.id && con.id === 'view') {
          con.name = tabName;
          newConstraint.view = con;
        } else {
          var newResources = Object.assign({}, con);
          var newfilter_base = {};

          _.each(newResources.filter_base, function (fi) {
            newfilter_base[fi.id] = Object.assign({}, fi);
          });

          newResources.filter_base = newfilter_base;

          if (newResources.filtered) {
            var newFiltered = {};
            _.each(newResources.filtered, function (fi) {
              newFiltered[fi.id] = Object.assign({}, fi);
            });

            newResources.filtered = newFiltered;
          }
          newConstraint.filter_datasources = newResources;
        }
      });

      newSourceContext.constraints = newConstraint;
      return newSourceContext;
    },

    normalizeFormat: function(source_context) {
      if (!source_context) {
        return {
          constraints: {
            view: {}
          }
        };
      }

      if (Array.isArray(source_context.constraints)) {
        var first = source_context.constraints[0] || {};
        return {
          constraints: {
            view: {
              unparsed: first.unparsed || "",
              expandable: !!first.expandable,
              name: first.name || first.unparsed || ""
            }
          }
        };
      }

      if (_.isObject(source_context.constraints)) {
        return source_context;
      }

      return {
        constraints: {
          view: {}
        }
      };
    }
  }
});

